import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "model-shell" }
const _hoisted_2 = { class: "model-header" }
const _hoisted_3 = { class: "model-header-main" }
const _hoisted_4 = { class: "model-provider-avatar" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "model-title-wrap" }
const _hoisted_8 = { class: "model-title-row" }
const _hoisted_9 = { class: "model-title" }
const _hoisted_10 = { class: "model-subtitle" }
const _hoisted_11 = { class: "model-header-actions" }
const _hoisted_12 = { class: "model-spec" }
const _hoisted_13 = { class: "model-spec-v model-spec-v-mono" }
const _hoisted_14 = { class: "model-spec" }
const _hoisted_15 = { class: "model-spec-v" }
const _hoisted_16 = {
  key: 0,
  class: "model-spec model-spec--pricing-inline"
}
const _hoisted_17 = { class: "model-spec-v model-spec-v-pricing-inline" }
const _hoisted_18 = { class: "model-spec-pricing-value" }
const _hoisted_19 = {
  key: 1,
  class: "model-spec model-spec--pricing-inline"
}
const _hoisted_20 = { class: "model-spec-v model-spec-v-pricing-inline" }
const _hoisted_21 = { class: "model-spec-pricing-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "model-desktop-card",
    color: "background",
    variant: "elevated",
    elevation: "4",
    onClick: _ctx.emitEdit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.showStandaloneIcon && _ctx.iconMode !== 'mono')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: (_ctx.icon as ProviderIcon).src,
                    alt: `${_ctx.config.providerKey} icon`,
                    class: "model-provider-avatar-image",
                    onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIconError && _ctx.onIconError(...args)))
                  }, null, 40, _hoisted_5))
                : (_ctx.showStandaloneIcon)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "model-provider-avatar-mask",
                      style: _normalizeStyle(_ctx.iconMaskStyle),
                      role: "img",
                      "aria-label": `${_ctx.config.providerKey} icon`
                    }, null, 12, _hoisted_6))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: "model-provider-avatar-fallback",
                      style: _normalizeStyle({ backgroundColor: _ctx.brandColor })
                    }, _toDisplayString(_ctx.providerInitials), 5))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.config.name), 1),
                (_ctx.isSystemLike)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      size: "x-small",
                      color: "primary",
                      variant: "flat",
                      class: "model-flag-chip"
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" DEFAULT ")
                      ])),
                      _: 1,
                      __: [1]
                    }))
                  : (_ctx.config.programmaticToolCalling)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 1,
                        size: "x-small",
                        color: "warning",
                        variant: "tonal",
                        class: "model-flag-chip"
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode(" TOOLS ")
                        ])),
                        _: 1,
                        __: [2]
                      }))
                    : _createCommentVNode("", true),
                (_ctx.configuredModelRetired)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 2,
                      size: "x-small",
                      color: "warning",
                      variant: "tonal",
                      class: "model-flag-chip"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" RETIRED MODEL ")
                      ])),
                      _: 1,
                      __: [3]
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.config.providerKey), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_tooltip, {
              text: "Edit Model",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  color: "primary",
                  icon: "mdi-pencil-outline",
                  size: "small",
                  variant: "plain",
                  class: "model-edit-icon",
                  onClick: _withModifiers(_ctx.emitEdit, ["stop"])
                }), null, 16, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_tooltip, {
              text: "Copy Model",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  color: "primary",
                  icon: "mdi-content-copy",
                  size: "small",
                  variant: "plain",
                  onClick: _withModifiers(_ctx.copyModel, ["stop"])
                }), null, 16, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["model-spec-grid", { 'model-spec-grid--with-pricing': _ctx.hasVisiblePricing }])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "model-spec-k" }, "Model", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.modelChipLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "model-spec-k" }, "Description", -1)),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.summaryDescription), 1)
          ]),
          (_ctx.inputRate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "model-spec-pricing-label" }, "Input", -1)),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.inputLabel), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.outputRate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "model-spec-pricing-label" }, "Output", -1)),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.outputLabel), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
}